<template>
  <v-btn v-if="value" icon small>
    <v-icon small v-tooltip="tooltipHtml">mdi-note-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'AdminCellNotesPopup',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
    tooltipHtml() {
      return {
        content: `<div class="proxima--font">${this.value}</div>`,
        html: true,
      }
    }, // tooltipHtml
  },
}
</script>
